module.exports = __webpack_public_path__ + "img/配置管理.c519554b.jpg";